import { AdminCargoDetailPage } from "@/pages/admin-cargo-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/admin/cargos/$id/")({
  component: () => {
    const { id: cargoIdStr } = useParams({
      from: "/_auth_requeired/admin/cargos/$id/",
    });
    return <AdminCargoDetailPage cargoIdStr={cargoIdStr} />;
  },
});
